$(function(){

    $('.carousel').each(function(key, item) {
       $(this).carousel({
           interval: 4000 // Never scrolls automatically
       });
    });


    // Clicking on link slides carousel to slide id [0-...
    // id is passed through data-slide="" attribute
    $('.carousel-control-slide').click(function(){
        if(this.dataset) {
            $(this.dataset.carousel).carousel(Number(this.dataset.slide));
        }
    });

});